var path = '/StructureObjectForm'

function get (http, id) {
    return http.get(path + `/Get?id=${id}&getComponents=true`)
}
function put (http, dto) {
    return http.put(path + '?saveComponents=true', dto)
}
function search (http, dto) {
    return http.post(path + '/Search?getComponents=true', dto)
}
export default {
    get: get,
    put: put,
    search: search
}



// WEBPACK FOOTER //
// ./src/services/siteForm/structureObjectFormService.js